<!--
    描述：人员管理--人员列表
    时间：2020-04-22
    Created by yefan
-->
<template>
    <div class="h100">
        <div class="w-table-layout">
            <div class="w-table-content" ref="usersContent">
                <el-table v-loading="usersData.loading" :data="usersData.tableData" :border="true"
                          :height="usersData.tableH" ref="softWareTable" highlight-current-row>
                    <el-table-column type="index" align="center" width="50">
                    </el-table-column>
                    <el-table-column label="操作" align="center" show-overflow-tooltip width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" icon="el-icon-edit"
                                       title="编辑" type="text"
                                       v-if="roleBtns.includes('user_edit')"
                                       @click="doClick(scope.row,'edit')"></el-button>
                            <el-button size="mini" icon="el-icon-search"
                                       title="查看" type="text"
                                       v-if="roleBtns.includes('user_view')"
                                       @click="doClick(scope.row,'view')"></el-button>
                            <el-button size="mini" icon="el-icon-delete"
                                       title="删除" type="text"
                                       v-if="roleBtns.includes('user_delete')"
                                       @click="doClick(scope.row,'delete')"></el-button>
                            <el-button size="mini" icon="el-icon-link"
                                       title="重置密码" type="text"
                                       v-if="roleBtns.includes('reset_password')"
                                       @click="doClick(scope.row,'reset')"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sname" align="center" label="人员姓名" show-overflow-tooltip
                                     min-width="120"></el-table-column>
                    <el-table-column prop="username" align="center" label="用户名" show-overflow-tooltip
                                     min-width="120"></el-table-column>
                    <el-table-column prop="deptName" align="center" label="部门" show-overflow-tooltip
                                     min-width="180"></el-table-column>
                    <el-table-column label="账号状态" align="center" width="100">
                        <template slot-scope="scope">
                            <el-button plain
                                       size="mini" :type="scope.row.isFlag===1 ? 'primary':'danger'"
                                       v-if="roleBtns.includes('user_status')"
                                       @click="doClick(scope.row,'forbid')">{{scope.row.isFlag===1? "启用":"禁用"}}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="w-table-footer">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="usersData.currentPage" :page-sizes="usersData.pageList"
                               :page-size="usersData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                               :total="usersData.total"></el-pagination>
            </div>
        </div>
        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width"
                   :close-on-click-modal="false">
            <!-- 弹窗组件 -->
            <addUser ref="addUser" :mode="mode" :userId="userId" v-if="dialogObj.visible"
                     @dialogClose="handleClose"></addUser>
            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center" v-if="dialogObj.mode !== 'view'">
                <el-button size="small" @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="btnLoading" @click="doSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import addUser from './add_user_dialog'
    import {deleteById, getUsers, updateUserState, resetPassword} from '@/api/modules/user.js'

    export default {
        components: {addUser},
        props: {
            searchObj: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        data() {
            return {
                btnLoading: false,
                dialogObj: {
                    title: '',
                    visible: false,
                    width: '500px',
                    mode: 'add',
                },
                usersData: {
                    loading: false,
                    tableH: 400,
                    tableData: [],
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                    pageList: [10, 20, 50, 100] // 显示条数数组
                },
                mode: '',
                userId: null,
                deptId: ''
            }
        },
        methods: {
            //新增、修改、删除等操作按钮点击事件
            doClick(row, type) {
                this.mode = type;
                if (type === 'add') {
                    if (this.deptId) {
                        this.dialogObj.title = '新增人员';
                        this.dialogObj.visible = true;
                    } else {
                        this.$message.warning("请单击左侧组织架构树选择新增人员所属单位！");
                    }
                } else if (type === 'edit') {
                    this.userId = row.id;
                    this.dialogObj.title = '编辑人员信息';
                    this.dialogObj.visible = true;
                } else if (type === 'view') {
                    this.userId = row.id;
                    this.dialogObj.title = '查看人员信息';
                    this.dialogObj.visible = true;
                } else if (type === 'delete') {
                    this.$confirm('确认删除该用户', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let param = {};
                        param.id = row.id;
                        deleteById(param).then(res => {
                            (res.operationCode === 1) ? this.$message.success("删除成功！") : this.$message.error(res.msg);
                            this.getUsers();
                        });
                    })
                } else if (type === 'reset') {
                    //重置密码
                    this.$confirm('确定重置该用户密码？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let param = {};
                        param.id = row.id;
                        resetPassword(param).then(res => {
                            if (res.operationCode === 1) {
                                this.$message.success("重置密码成功！")
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    })
                } else {
                    let message = (row.isFlag === 1) ? '确认禁用该用户？' : '确认启用该用户？';
                    this.$confirm(message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let param = {};
                        param.id = row.id;
                        param.isFlag = (row.isFlag === 1) ? 0 : 1;
                        updateUserState(param).then(res => {
                            (res.code === 0) ? this.$message.success("操作成功！") : this.$message.error(res.msg);
                            this.getUsers();
                        });
                    })
                }
            },
            getUsers(deptId) {
                // console.log(JSON.stringify(this.searchObj));
                // this.deptId = deptId;
                let param = {};
                param.sname = this.searchObj.sname;
                param.deptId = this.deptId;
                param.current = this.usersData.currentPage;
                param.size = this.usersData.pageSize;
                getUsers(param).then(res => {
                    this.usersData.tableData = res.data.records;
                    this.usersData.total = parseInt(res.data.total);
                });
            },
            // 关闭弹窗事件
            handleClose() {
                this.dialogObj.visible = false;
                this.getUsers();
            },
            // 确定按钮事件
            doSave() {
                this.$refs.addUser.doSave(this.deptId);
            },
            // 切换显示条数
            handleSizeChange(val) {
                this.usersData.pageSize = val;
                this.getUsers()
            },
            // 切换当前页码
            handleCurrentChange(cur) {
                this.usersData.currentPage = cur;
                this.getUsers()
            }
        },
        created() {
            this.getUsers();
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.usersData.tableH = this.$refs.usersContent.offsetHeight - 45;
                }, 100)
            })
        },
        // 进入缓存页面
        activated() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.usersData.tableH = this.$refs.usersContent.offsetHeight - 45;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                routeList: state => state.routeList,
                roleBtns: state => state.roleBtns
            }),
        },
        watch: {
            clientSize(val) {
                this.usersData.tableH = this.$refs.usersContent.offsetHeight - 45;
            }
        }
    }
</script>
<style lang="less">

</style>
